import React from "react";

const MainConteiner = ({ children }) => {
  return (
    <div className="min-h-screen px-10 py-6 bg-white w-full">{children}</div>
  );
};

export default MainConteiner;
